import { useParams } from 'react-router-dom'
import ModuleRecordForm from './ModuleRecordForm'
import { v4 as uuidv4 } from 'uuid'

const View = () => {
    const params = useParams()

    return (
        <ModuleRecordForm
            inPopup={false}
            module={params.module}
            id={parseInt(params.recordId)}
            tempToken={uuidv4()}
            config={{
                submitSuccessMsg: {
                    header: 'Updated',
                    message: 'Record updated successfully',
                },
                submitFailedMsg: {
                    header: 'Failed',
                    message: 'Failed to update record',
                },
                saveButton: {
                    label: 'Update',
                    savingLabel: 'Updating record...',
                },
            }}
        />
    )
}

export default View
